module.exports = __webpack_public_path__ + "static/media/308.3639c48b.png";